import React from 'react';
import PropTypes from 'prop-types';

import BookingConfirmation, {
  getBookingConfirmationProps
} from '@components/pages/booking-confirmation/bookingConfirmation';
import CurrentPage, { getCurrentPageProps } from '@components/pages/currentPage/currentPage';
import LandingPage from '@components/pages/landing/landing';
import Newsroom, { getNewsroomProps } from '@components/pages/newsroom/newsroom';
import Token, { getTokenProps } from '@components/pages/token/token';
import { appSetPageData } from '@redux/actions/app';
import { wrapper } from '@redux/store';

const Page = props => {
  const { PAGE_TYPE, type, tokenId, floorPlanDataUrl } = props;

  if (PAGE_TYPE === 'TOKEN') {
    return <Token tokenId={tokenId} floorPlanDataUrl={floorPlanDataUrl} {...props} />;
  }

  if (PAGE_TYPE === 'NEWSROOM') {
    return <Newsroom data={props} />;
  }

  if (PAGE_TYPE === 'BOOKINGCONFIRMATION') {
    // console.log('bookwtf');
    return <BookingConfirmation {...props} />;
  }

  if (PAGE_TYPE === 'UNIVERSAL' && type === 'landingpageSimple') {
    return <LandingPage {...props} />;
  }

  return <CurrentPage data={props} />;
};

export const getServerSideProps = wrapper.getServerSideProps(
  store =>
    async ({ locale, params: { uri, uri2 }, query: { page, goUrl }, resolvedUrl }) => {
      let props = null;

      if (['my-exhibition', 'meine-ausstellung'].includes(uri)) {
        props = await getTokenProps({ locale, tokenId: uri2, page });
      } else if (['about-us', 'ueber-uns'].includes(uri) && ['newsroom', 'presse'].includes(uri2)) {
        props = await getNewsroomProps({ locale, category: uri, slug: uri2 });
      } else if (['booking'].includes(uri) && ['confirmed'].includes(uri2)) {
        props = await getBookingConfirmationProps({ locale, goUrl });
      } else {
        props = await getCurrentPageProps({ locale, resolvedUrl });
      }

      await store.dispatch(appSetPageData(props));

      return {
        props,
        notFound: !props?.PAGE_TYPE || !!props?.error
      };
    }
);

Page.propTypes = {
  data: PropTypes.shape().isRequired,
  tokenId: PropTypes.string.isRequired,
  floorPlanDataUrl: PropTypes.string.isRequired,
  PAGE_TYPE: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
};

export default Page;
